export default "__VITE_ASSET__BCfKzVzr__"